/*=========================================================================================
  File Name: moduleMapState.js
  Description: Todo Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
	navbarColor: "#0B8FF4", //'#111350',      // options[String]  : HEX color / rgb / rgba / Valid HTML Color name - (default: #fff)
};
